
export function getChannelSelectorTarget(channel) {
  return channel.target ? {
    target: {
      id: channel.target.id,
      collection: channel.target.collection,
    },
    overrideOrg: channel.org,
  } : {};
}



// WEBPACK FOOTER //
// ./src/js/comments/utils/index.js